const create = (items, value) =>
  items.reduce(
    (acc, item) => ({
      ...acc,
      [item]: value,
    }),
    {}
  );

const createBatch = ({ elementIds, targets, value }) => create(elementIds, create(targets, value));

export default createBatch;
